module.exports = __webpack_public_path__ + "img/logo.8c880969.svg";